import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import AccountController from './account.controller';
import { Layout, Loading } from '../common';
import { Button as AntButton, Input as AntInput, Alert } from 'antd';
import { MailOutlined, LockOutlined, UserOutlined, PhoneOutlined } from '@ant-design/icons';
import styles from './styles/account.module.scss';

class Account extends Inherit(AccountController, Component) {
    render() {
        const { 
            user, 
            loading,
            firstName,
            lastName,
            email,
            phoneNumber,
            currentPassword,
            newPassword,
            confirmPassword,
            showPasswordSection,
            saving,
            error,
            successMessage
        } = this.state;

        if (loading) {
            return (
                <Layout user={user} fi={user?.fi?.name}>
                    <Loading />
                </Layout>
            );
        }

        return (
            <Layout user={user} fi={user?.fi?.name}>
                <div className={styles.accountContainer}>
                    <div className={styles.header}>
                        <h1 className={styles.title}>Account Settings</h1>
                        <p className={styles.subtitle}>Manage your account information and preferences</p>
                    </div>

                    {successMessage && (
                        <Alert
                            message={successMessage}
                            type="success"
                            showIcon
                            closable
                            className={styles.successAlert}
                        />
                    )}

                    <div className={styles.contentWrapper}>
                        {/* Personal Information Section */}
                        <div className={styles.section}>
                            <h2 className={styles.sectionTitle}>Personal Information</h2>
                            
                            <div className={styles.formGrid}>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>First name</label>
                                    <AntInput
                                        size="large"
                                        prefix={<UserOutlined className={styles.inputIcon} />}
                                        value={firstName}
                                        onChange={(e) => this.setFirstName(e.target.value)}
                                        placeholder="First name"
                                        status={error ? 'error' : ''}
                                        className={styles.input}
                                    />
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Last name</label>
                                    <AntInput
                                        size="large"
                                        prefix={<UserOutlined className={styles.inputIcon} />}
                                        value={lastName}
                                        onChange={(e) => this.setLastName(e.target.value)}
                                        placeholder="Last name"
                                        status={error ? 'error' : ''}
                                        className={styles.input}
                                    />
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Email</label>
                                    <AntInput
                                        size="large"
                                        prefix={<MailOutlined className={styles.inputIcon} />}
                                        type="email"
                                        value={email}
                                        onChange={(e) => this.setEmail(e.target.value)}
                                        placeholder="email@example.com"
                                        status={error ? 'error' : ''}
                                        className={styles.input}
                                    />
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Phone number</label>
                                    <AntInput
                                        size="large"
                                        prefix={<PhoneOutlined className={styles.inputIcon} />}
                                        addonBefore="+1"
                                        value={phoneNumber}
                                        onChange={(e) => this.setPhoneNumber(e.target.value)}
                                        placeholder="(555) 123-4567"
                                        status={error ? 'error' : ''}
                                        className={styles.input}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Password Section */}
                        <div className={styles.section}>
                            <div className={styles.sectionHeader}>
                                <h2 className={styles.sectionTitle}>Password</h2>
                                <AntButton
                                    type="link"
                                    onClick={this.handleTogglePasswordSection.bind(this)}
                                    className={styles.changePasswordButton}
                                >
                                    {showPasswordSection ? 'Cancel' : 'Change Password'}
                                </AntButton>
                            </div>

                            {showPasswordSection && (
                                <div className={styles.passwordSection}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Current password</label>
                                        <AntInput.Password
                                            size="large"
                                            prefix={<LockOutlined className={styles.inputIcon} />}
                                            value={currentPassword}
                                            onChange={(e) => this.setCurrentPassword(e.target.value)}
                                            placeholder="Enter current password"
                                            status={error ? 'error' : ''}
                                            className={styles.input}
                                        />
                                    </div>

                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>New password</label>
                                        <AntInput.Password
                                            size="large"
                                            prefix={<LockOutlined className={styles.inputIcon} />}
                                            value={newPassword}
                                            onChange={(e) => this.setNewPassword(e.target.value)}
                                            placeholder="Enter new password"
                                            status={error ? 'error' : ''}
                                            className={styles.input}
                                        />
                                    </div>

                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Confirm new password</label>
                                        <AntInput.Password
                                            size="large"
                                            prefix={<LockOutlined className={styles.inputIcon} />}
                                            value={confirmPassword}
                                            onChange={(e) => this.setConfirmPassword(e.target.value)}
                                            placeholder="Confirm new password"
                                            status={error ? 'error' : ''}
                                            className={styles.input}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Action Buttons */}
                        <div className={styles.actions}>
                            <AntButton
                                size="large"
                                onClick={this.handleCancel.bind(this)}
                                className={styles.cancelButton}
                            >
                                Cancel
                            </AntButton>
                            <AntButton
                                type="primary"
                                size="large"
                                loading={saving}
                                onClick={() => this.handleSaveChanges()}
                                className={styles.saveButton}
                            >
                                Save Changes
                            </AntButton>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default withHooks(Account);

